import moment from 'moment';
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import AssessmentLogin from './assessmentLogin';
import AssessmentSignup from './assessmentSignup';
import AssessmentPasswordlessAuth from './assessmentPasswordlessAuth';
import InitializeProfile from './initializeProfile';
import ManageProfile from './manageProfile';
import AssessmentView from './assessmentView';
import AssessmentsList from './assessmentsList';

import AssessmentWelcome from './assessmentWelcome';
import InvalidAssessmentLink from './invalidAssessmentLink';
import ExpiredAssessmentLink from './expiredAssessmentLink';

import qs from 'qs';

import {
  Localize,
} from '../shared';

import {
  callIfFunction,
  getLocaleFromBrowser
} from '../../util';

import {
  fetchOrgConfig,
  fetchAssessmentConfig,
  activateLocalization,
} from '../../actions';

import {
  initializeAssessment,
  fetchMyAssessments,
  updateAssessment,
  updateAssessmentResponses,
  viewingAssessmentResults,
  completeAssessment,
  submitAssessmentForScoring,
} from '../../actions/assessments';

import {
  ChangeLocalizationModal
} from '../modals';

class TakeAssessmentPage extends Component {

  state = {
    showAuthForm: 'passwordless',
    takingAssessment: null,
    submittingAssessmentForScoring: false,
    showLanguageSelect: false,
    languageSelected: false,
    assessmentsLoaded: false,
    initializingAssessment: false,
    assessmentWelcomeAcknowledged: false,
    assessmentLinkIsInvalid: false,
    loadingAssessmentConfig: false,
    assessmentConfigLoaded: false,
    assessmentConfig: null,
  }

  assessmentName(){
    return this.props.match.params.assessmentName;
  }

  assessmentConfig(){
    return this.props.assessmentConfig || null;
  }

  refreshAssessmentsToCheckForScoringCompletion(){

    const userHasAssessmentsBeingScored = _.findLast(_.sortBy(this.props.myAssessments, 'completedOn'), assessment => {
      return assessment.status === 'scoring' || assessment.status === 'complete';
    });

    if(userHasAssessmentsBeingScored){
      //reload assessments
      this.setState({
        assessmentsLoaded: false
      });

      this.props.fetchMyAssessments();
    }
    else{
      //do nothing, no assessments being scored
    }
  }

  profileNameFromParams(){
    const params = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });

    const profileName = params.profile;

    return profileName || null;
  }

  initComponentAssessmentData(){

    const assessmentName = this.assessmentName();
    const organizationId = this.getOrganizationId();

    const {
      user,
      authenticating,
      myAssessments,
    } = this.props;

    const {
      assessmentsLoaded,
      loadingAssessmentConfig,
      assessmentConfigLoaded,
      assessmentLinkIsInvalid,
      assessmentLinkIsExpired,
    } = this.state;

    //profile = reserved name
    if(assessmentName && assessmentName !== 'profile' && !loadingAssessmentConfig && !assessmentConfigLoaded){
      this.setState({
        loadingAssessmentConfig: true
      }, () => {

        // console.log('fetching assessment config for name: ', assessmentName);

        this.props.fetchAssessmentConfig(assessmentName, assessmentConfig => {
          console.log('found assessment config', assessmentConfig);

          if(!assessmentConfig || !assessmentConfig.organization || !assessmentConfig.profileNames || !assessmentConfig.profileNames[this.profileNameFromParams()]){
            this.setState({
              loadingAssessmentConfig: false,
              assessmentConfigLoaded: true,
              assessmentLinkIsInvalid: true,
            });
          }
          else if(assessmentConfig.endDate && moment().diff(assessmentConfig.endDate.toDate()) > 0){
            this.setState({
              loadingAssessmentConfig: false,
              assessmentConfigLoaded: true,
              assessmentLinkIsExpired: true,
            })
          }
          else{
            this.setState({
              loadingAssessmentConfig: false,
              assessmentConfigLoaded: true
            });
          }
        });
      });
    }

    // console.log('organization Id: ', organizationId);

    //show assessment welcome since user not logged in & is taking specific assessment name
    if(!this.props.user.uid && !authenticating && this.props.assessmentConfig && !this.props.activeLocalization){
      this.props.activateLocalization(getLocaleFromBrowser(), this.props.assessmentConfig.organization);
    }

    if(organizationId && !this.props.orgConfig){
      this.props.fetchOrgConfig(organizationId);
    }

    if(this.props.user.uid && !this.props.myAssessments && !this.props.loadingMyAssessments){
      console.log('fetching my assessments!');

      this.props.fetchMyAssessments();
    }

    if(this.props.user.uid && !assessmentsLoaded && _.size(myAssessments) > 0){

      const lastInProgressAssessment = _.findLast(_.sortBy(myAssessments, 'lastUpdated'), assessment => {
        return assessment.status === 'inprogress';
      });

      const lastScoredAssessment = _.findLast(_.sortBy(myAssessments, 'completedOn'), assessment => {
        return assessment.status === 'scored';
      });

      const currentlyScoringAnAssessment = _.findLast(_.sortBy(myAssessments, 'completedOn'), assessment => {
        return assessment.status === 'scoring' || assessment.status === 'complete';
      });

      if(currentlyScoringAnAssessment){
        setTimeout(this.refreshAssessmentsToCheckForScoringCompletion.bind(this), 5000);
      }

      this.setState({
        assessmentsLoaded: true
      });
    }

    //show initial language selection if none set
    if(user && !authenticating && !user.preferredLanguage && !this.state.showLanguageSelect && !this.state.languageSelected){

      const assessmentConfig = this.assessmentConfig();

      if(assessmentConfig && assessmentConfig.languages && _.size(assessmentConfig.languages) > 1){
        this.setState({
          showLanguageSelect: true
        });
      }
    }
  }

  componentDidMount(){
    this.initComponentAssessmentData();
  }

  componentDidUpdate(prevProps, prevState){
    // console.log('takeAssessment/index component did update: ', this.state, this.props);
    this.initComponentAssessmentData();
  }

  userIsLoggedIn(){
    return this.props.user !== false;
  }

  renderAssessmentSignup(){
    return (
      <AssessmentSignup
        showLoginForm={() => { this.setState({ showAuthForm: 'login' }) }}
      />
    )
  }

  renderAssessmentLogin(){
    return (
      <AssessmentLogin
        showSignupForm={() => { this.setState({ showAuthForm: 'signup' }) }}
      />
    )
  }

  renderPasswordlessAuth(){
    return (
      <AssessmentPasswordlessAuth assessmentConfig={this.assessmentConfig()} />
    )
  }

  getOrganizationId(){
    const {
      assessmentConfig,
      user
    } = this.props;

    //use user's assessment org prop if set
    if(user.currentAssessmentConfig && user.currentAssessmentConfig.organization){
      return user.currentAssessmentConfig.organization;
    }
    else if(user.organizationId){
      return user.organizationId;
    }

    //otherwise lookup from URL
    const assessmentLookup = this.props.match.params.assessmentName;

    if(!assessmentLookup || !assessmentConfig){
      return false;
    }
    else{
      return assessmentConfig.organization;
    }
  }

  orgDisplayName(){
    const { orgConfig } = this.props;

    return orgConfig ? orgConfig.name : '';
  }

  orgLogo(){
    const { orgConfig } = this.props;

    return orgConfig ? orgConfig.logo : '';
  }

  initializeAssessment(){
    this.setState({
      initializingAssessment: true
    });

    console.log('USER DATA IA: ', this.props.user);

    const {
      profile,
      profileName,
      batchLabel,
      grouping,
      organization,
      assessmentName,
    } = this.props.user.currentAssessmentConfig;

    this.props.initializeAssessment({
      assessmentName: this.assessmentConfig().name,
      playbookVersion: this.assessmentConfig().playbookVersion,
      assessmentVersion: this.assessmentConfig().assessmentVersion,
      scoredProfiles: this.assessmentConfig().scoredProfiles,
      experiments: this.assessmentConfig().experiments,
      organization: this.assessmentConfig().organization,
      withholdResults: this.assessmentConfig().withholdResults,
      scoringAlgoVersion: this.assessmentConfig().scoringAlgoVersion,
      profile,
      profileName,
      grouping,
      batchLabel,
      locale: this.props.activeLocalization ? this.props.activeLocalization._id : 'en',
    }, newAssessmentData => {

      console.log('should be taking assessment: ', newAssessmentData);

      this.props.fetchMyAssessments(() => {
        this.setState({
          initializingAssessment: false,
          takingAssessment: newAssessmentData
        });
      });
    });
  }

  renderWelcomeMessage(){

    const { initializingAssessment } = this.state;

    const assessmentName = (this.assessmentConfig() || {}).name;

    return (
      <div className="welcome-message">
        <h2><Localize id={`assessment_${assessmentName}_intro_header`}><Localize id="assessment_default_intro_header"/></Localize></h2>
        <p><Localize id={`assessment_${assessmentName}_intro_body`}><Localize id="assessment_default_intro_body" breakType="paragraph"/></Localize></p>
        <p><button
          onClick={this.initializeAssessment.bind(this)}
          disabled={initializingAssessment}
          className="button blue-button">{!initializingAssessment ? <Localize id="btn_begin_assessment" /> : <Localize id="btn_initializing" />}</button></p>
      </div>
    )
  }

  updateQuestionResponse(questionId, response){

    const updatedAssessment = {
      ...this.state.takingAssessment,
      responses: {
        ...this.state.takingAssessment.responses,
        [questionId]: response
      }
    }

    this.setState({
      takingAssessment: updatedAssessment
    });
  }

  updateQuestionResponses(responses, callback){

    const updatedAssessment = {
      ...this.state.takingAssessment,
      responses: {
        ...this.state.takingAssessment.responses,
        ...responses
      }
    }

    this.setState({
      takingAssessment: updatedAssessment
    }, () => {
      callback();
    });
  }

  saveAssessmentProgress(callback){
    this.props.updateAssessmentResponses(this.state.takingAssessment, () => {
      callIfFunction(callback);
    });
  }

  completeAndSubmitAssessmentForScoring(afterSubmission, afterScoring){
    this.setState({
      completingAssessment: true
    });

    this.props.completeAssessment(this.state.takingAssessment, completedAssessment => {
      this.setState({
        completingAssessment: false,
        submittingAssessmentForScoring: true
      });

      callIfFunction(afterSubmission);

      this.props.submitAssessmentForScoring(this.state.takingAssessment._id, result => {

        console.log('completed with result: ', result);

        this.setState({
          submittingAssessmentForScoring: false,
          takingAssessment: null,
          assessmentsLoaded: false
        });

        this.props.fetchMyAssessments();

        callIfFunction(afterScoring);
      });
    });
  }

  renderAssessmentView(){
    const {
      takingAssessment,
      completingAssessment,
      submittingAssessmentForScoring,
    } = this.state;

    return (
      <AssessmentView
        orgDisplayName={this.orgDisplayName()}
        assessment={takingAssessment}
        updateQuestionResponse={this.updateQuestionResponse.bind(this)}
        updateQuestionResponses={this.updateQuestionResponses.bind(this)}
        saveProgress={this.saveAssessmentProgress.bind(this)}
        completeAndSubmitAssessmentForScoring={this.completeAndSubmitAssessmentForScoring.bind(this)}
        submittingAssessmentForScoring={submittingAssessmentForScoring}
        completingAssessment={completingAssessment}
      />
    )
  }

  renderInitializeProfile(){
    return (
      <InitializeProfile assessmentConfig={this.assessmentConfig()} />
    );
  }

  profileInitialized(){
    return this.props.user && this.props.user.firstName;
  }

  renderAuthView(){
    const { showAuthForm } = this.state;

    return (
      <React.Fragment>
        {showAuthForm === 'signup' && this.renderAssessmentSignup()}
        {showAuthForm === 'login' && this.renderAssessmentLogin()}
        {showAuthForm === 'passwordless' && this.renderPasswordlessAuth()}
      </React.Fragment>
    )
  }

  renderAssessmentsList(){
    const {
      myAssessments
    } = this.props;

    return (
      <AssessmentsList
        orgConfig={this.props.orgConfig || {}}
        user={this.props.user}
        orgDisplayName={this.orgDisplayName()}
        assessments={myAssessments}
        resumeAssessment={assessment => { this.setState({ takingAssessment: assessment }); }}
      />
    )
  }

  renderManageProfile(){
    return (
      <ManageProfile
        user={this.props.user}
      />
    )
  }

  render(){

    const {
      takingAssessment,
      viewingAssessmentResults,
      showLanguageSelect,
      assessmentWelcomeAcknowledged,
      assessmentLinkIsInvalid,
      assessmentLinkIsExpired,
      loadingAssessmentConfig,
    } = this.state;

    if(assessmentLinkIsInvalid){
      return (
        <InvalidAssessmentLink />
      )
    }
    else if(assessmentLinkIsExpired){
      return (
        <ExpiredAssessmentLink />
      )
    }

    if(loadingAssessmentConfig){
      return (
        <h1><Localize id="txt_loading_assessment">Loading assessment...</Localize></h1>
      )
    }

    // console.log('render called with takingAssessment: ', takingAssessment);
    // console.log('render called with viewingAssessmentResults: ', viewingAssessmentResults);

    const { user, authenticating, authenticated, loadingMyAssessments, myAssessments } = this.props;

    const profileInitialized = this.profileInitialized();

    const showManageProfileView = this.props.match.params.assessmentName === 'profile';

    const hasInProgressOrCompletedAssessment = _.size(myAssessments) > 0;

    const assessmentConfig = this.assessmentConfig();

    return (
      <div className="take-assessment">
        {!user && assessmentWelcomeAcknowledged && this.renderAuthView()}

        {user && authenticating &&
          <div className="loading-message"><Localize id="txt_loading">Loading profile...</Localize></div>
        }

        {user && !authenticating && loadingMyAssessments &&
          <div className="loading-message"><Localize id="txt_loading_assessment">Loading assessment...</Localize></div>
        }

        {user && !authenticating && !loadingMyAssessments && !showManageProfileView &&
          <React.Fragment>
            {!profileInitialized && this.renderInitializeProfile()}
            {profileInitialized &&
              <React.Fragment>
                {!hasInProgressOrCompletedAssessment && this.renderWelcomeMessage()}
                {hasInProgressOrCompletedAssessment && takingAssessment && this.renderAssessmentView()}
                {hasInProgressOrCompletedAssessment && !takingAssessment && this.renderAssessmentsList()}
              </React.Fragment>
            }
          </React.Fragment>
        }
        {user && !authenticating && !loadingMyAssessments && showManageProfileView && this.renderManageProfile()}

        <ChangeLocalizationModal languages={assessmentConfig ? assessmentConfig.languages : false} visible={showLanguageSelect} hide={() => { this.setState({ showLanguageSelect: false, languageSelected: true }) }} />

        {!user && !assessmentWelcomeAcknowledged && this.assessmentConfig() &&
          <AssessmentWelcome assessmentConfig={this.assessmentConfig()} hide={() => { this.setState({ assessmentWelcomeAcknowledged: true }); }} urlParams={this.props.location.search} />
        }

      </div>
    )
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
    authenticating: state.user === 'authenticating',
    authenticated: (state.user && state.user.uid) ? true : false,
    orgConfig: state.orgConfig.data,
    assessmentConfig: state.assessmentConfig.data,
    activeLocalization: state.activeLocalization.data,

    loadingMyAssessments: state.myAssessments.loading,
    myAssessments: state.myAssessments.data
  }
}

export default connect(mapStateToProps, { fetchOrgConfig, fetchAssessmentConfig, activateLocalization, initializeAssessment, fetchMyAssessments, updateAssessment, updateAssessmentResponses, completeAssessment, submitAssessmentForScoring })(TakeAssessmentPage);



// WEBPACK FOOTER //
// ./src/components/takeAssessment/index.js